import { render, staticRenderFns } from "./SelectConfirmation.vue?vue&type=template&id=2220c84c&scoped=true&"
import script from "./SelectConfirmation.vue?vue&type=script&lang=js&"
export * from "./SelectConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SelectConfirmation.vue?vue&type=style&index=0&id=2220c84c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2220c84c",
  null
  
)

export default component.exports